import type { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ACCENT_STRIP_HEIGHT, ALPHA } from "../../theme/tokens";

/** The summary band: a brand wash fading across it — depth under the heading without reading as a callout — and a brand edge. */
export const headerBandSx: SxProps<Theme> = (theme) => ({
	position: "relative",
	display: "flex",
	alignItems: "flex-start",
	justifyContent: "space-between",
	flexWrap: "wrap",
	columnGap: 3,
	rowGap: 1,
	px: 2,
	pt: 1.75,
	pb: 1.5,
	background: `linear-gradient(100deg, ${alpha(theme.palette.primary.main, ALPHA.BRAND_TINT)} 0%, ${alpha(theme.palette.primary.main, ALPHA.HERO_WASH)} 55%, transparent 100%)`,
	borderBottom: `1px solid ${theme.palette.divider}`,
	"&::before": {
		content: '""',
		position: "absolute",
		insetInlineStart: 0,
		top: 0,
		bottom: 0,
		width: ACCENT_STRIP_HEIGHT,
		backgroundColor: theme.palette.primary.main,
	},
});
